module.exports = __webpack_public_path__ + "img/verified-members.eef4eb15.svg";